import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      <p className="font-heading text-6xl font-semibold tracking-widest text-primary-100 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-semibold text-foreground-950 md:text-2xl">页面不存在</h1>
      <p className="mt-2 text-[12px] text-foreground-400">{location.pathname}</p>
      <p className="mt-3 max-w-[420px] text-[13px] leading-6 text-foreground-500">
        这个地址可能已经调整，或者从未存在过。你可以回到首页，或者直接进入分类浏览。
      </p>
      <div className="mt-6 flex flex-col gap-2 sm:flex-row">
        <Link
          to="/"
          className="flex h-10 items-center justify-center whitespace-nowrap rounded-md bg-primary-600 px-5 text-[13px] text-background-50 transition-colors hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="flex h-10 items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-5 text-[13px] text-foreground-700 transition-colors hover:bg-background-100"
        >
          浏览全部内容
        </Link>
      </div>
    </div>
  );
}